import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { FormulaVariable } from './types';

export const psoFormulaVariablesApi = createApi({
  reducerPath: 'psoFormulaVariablesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/pso-formula-variables`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  tagTypes: ['FormulaVariables'],
  endpoints: builder => ({
    getFormulaVariables: builder.query<FormulaVariable[], void>({
      query: () => ({ url: '/' }),
      providesTags: () => ['FormulaVariables'],
    }),
  }),
});

export const { useGetFormulaVariablesQuery } = psoFormulaVariablesApi;
